import React from "react";
import cover from '../asset/cr.jpeg';

const Hero = () => {
    return(
        <section className="bg-cover bg-center h-screen text-white"
        style={{backgroundImage: `url(${cover})` }}
        >
            <div className="bg-black bg-opacity-60 h-full flex flex-col justify-center items-center text-center p-6">
                <h2 className="text-5xl font-bold mb-4" style={{ fontFamily: 'Young, serif' }}>Hello, I'm Septia Khairunnisa</h2>
                <p className="text-2xl mb-8">Kidi Intern</p>
                <a href="https://wa.me/+6288215734984" className="bg-lime-700 hover:bg-lime-500 text-white font-bold py-2 px-6 rounded-lg shadow-lgm transition duration-300">
                    Contact
                </a>
            </div>

        </section>
    )
}

export default Hero;